import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Input, Spin } from 'antd';
import axios from "axios";
import Swal from 'sweetalert2';
import { USER_SERVER } from '../../../config'
import './Chat.css';
import { PhoneTwoTone, ApiTwoTone, SendOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function ChatNoAudio() {
    const [UserId, setUserId] = useState('');
    const [WaitAnswer, setWaitAnswer] = useState(false);
    const [CallReady, setCallReady] = useState(true);
    const [Status, setStatus] = useState('ready');      // ready, intro_done, connect_done, start_done, need_close

    const [messages, setMessages] = useState([]);
    const [currentUserMessage, setCurrentUserMessage] = useState('');
    const [currentAssistantMessage, setCurrentAssistantMessage] = useState('');
    const currentAssistantMessageRef = useRef('');


    const historyRef = useRef(null);

    function get_user_id(new_flag = false) {
        let userId = localStorage.getItem('tele_user_id');
        if (!userId || new_flag) {
            userId = 'ts' + Date.now();
            localStorage.setItem('tele_user_id', userId);
        }
        return userId;
    }

    useEffect(() => {
        setUserId(get_user_id());
    }, []);


    useEffect(() => {
        if (UserId) {
            get_chat_history(UserId);
        }
    }, [UserId]);


    useEffect(() => {
        if (historyRef.current) {
            historyRef.current.scrollTop = historyRef.current.scrollHeight;
        }
    }, [messages, currentAssistantMessage]);


    ////////////////////////////////////////// HTTP //////////////////////////////////////////
    async function get_chat_history(user_id) {
        try {
            const res = await axios.post(`${USER_SERVER}/get_chat_history`, { user_id: user_id });
            console.log('get_chat_history--------->', res);
            if (res.data?.success) {
                let tmp_messages = [];
                for (let i = 0; i < res.data.data.length; i++) {
                    if (res.data.data[i].speaker === 'h') {
                        tmp_messages.push({ type: 'user', text: res.data.data[i].message });
                    } else {
                        tmp_messages.push({ type: 'assistant', text: res.data.data[i].message });
                    }
                }
                setMessages(tmp_messages);
            } else {
                show_error(res);
            }
        } catch (error) {
            console.error('Failed to fetch chat history:', error);
            // 서버 연결 실패 시 기본 메시지 설정
            setMessages([{ type: 'system', text: '서버에 연결할 수 없습니다.' }]);
        }
    }


    // error 나면 에러 정보를 디스플레이
    function show_error(res) {
        console.log('show error:', res);
        const tdata = res.data.data;
        if (typeof tdata === 'object' && 'title' in tdata) {
            Swal.fire({
                title: res.data.data.title,
                text: res.data.data.description,
                icon: 'info',
                confirmButtonText: '확인'
            });
        } else {
            Swal.fire({
                title: 'Error',
                text: res.data.data,
                icon: 'error',
                confirmButtonText: '확인'
            });
        }
    }



    //////////////////////////////////////////////// ChatBubble ////////////////////////////////////////////////

    function handleUserInputChange(e) {
        setCurrentUserMessage(e.target.value);
    };

    function handleUserSend(message) {
        if (message.trim()) {
            //setMessages([...messages, { type: 'user', text: currentUserMessage }]);
            setMessages(prevMessages => [...prevMessages, { type: 'user', text: message }]);
            setCurrentUserMessage('');
        }
    };

    function handleAssistantSend(message) {
        console.log('handleAssistantSend called:', message);
        if (message.trim()) {
            console.log('handleAssistantSend called 2');
            setMessages(prevMessages => [...prevMessages, { type: 'assistant', text: message }]);
        }
    }


    // async function onClickSend() {
    //     if (Status !== 'start_done') {
    //         return;
    //     }

    //     handleUserSend(currentUserMessage);
    //     await send_question(currentUserMessage);
    // }

    // async function send_question(question) {
    //     const res = await axios.post(`${USER_SERVER}/get_answer`, { user_id: UserId, question: question });
    //     console.log('answer--------->', res);
    //     if (res.data?.success) {
    //         handleGetAnswerResponse(res.data.answer);
    //     } else {
    //         show_error(res);
    //     }
    // }

    function handleGetAnswerResponse(res) {
        //console.log('socket_recv:answer', res);

        if (res === '<EOS>') {
            setWaitAnswer(false);
            handleAssistantSend(currentAssistantMessageRef.current);
            currentAssistantMessageRef.current = ''; // 메시지 초기화
            setCurrentAssistantMessage('');
        } else {
            currentAssistantMessageRef.current += res; // 메시지 추가
            setCurrentAssistantMessage(prevMessages => prevMessages + res); // UI 업데이트를 위해 상태 설정
        }
    };



    /////////////////////////////////////// TEST ///////////////////////////////////////
    async function onClickSendGetAnswer() {
        handleUserSend(currentUserMessage);
        const res = await axios.post(`${USER_SERVER}/get_answer`, { user_id: UserId, question: currentUserMessage });
        console.log('get_answer--------->', res);
        handleGetAnswerResponse(res.data.answer);
        handleGetAnswerResponse('<EOS>');
    }

    function onClickRestart() {
        setMessages([]);
        setCurrentUserMessage('');
        setCurrentAssistantMessage('');

        const new_user_id = get_user_id(true);
        console.log('new_user_id--------->', new_user_id);
        setUserId(new_user_id);
    }
    

    /////////////////////////////////////// Display ///////////////////////////////////////
    const normal_operation = true;


    return (
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            {/* chat history를 보여줌  */}
            <Row>
                <Col span={24}>
                    <div className="history" ref={historyRef}>
                        {messages.map((msg, index) => (
                            <div key={index} className={`message-bubble ${msg.type}`}>
                                {msg.text}
                            </div>
                        ))}
                        {/* Curr User:
                        {currentUserMessage && (
                            <div className="message-bubble user">
                                {currentUserMessage}
                            </div>
                        )} */}
                        {/* Curr Assistant: */}
                        {currentAssistantMessage && (
                            <div className="message-bubble assistant">
                                {currentAssistantMessage}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row justify="center" align='middle'>
                <Col span={22}>
                    <Input disabled={WaitAnswer} value={currentUserMessage} onChange={handleUserInputChange} onPressEnter={onClickSendGetAnswer} />
                </Col>
                <Col span={2}>

                    {
                        WaitAnswer ? <Spin /> :
                            <SendOutlined
                                onClick={onClickSendGetAnswer}
                                style={{ fontSize: '24px', margin: 10}}
                            />
                    }
                </Col>
            </Row>

            <Row align='middle' style={{ margin: 10 }}>
                <Col>
                    <Button type='primary' onClick={onClickRestart} style={{ margin: 10 }}>Restart</Button>
                </Col>
            </Row>
            {/* <Row align='middle' style={{ margin: 10 }}>
                <Col>Mic Control:</Col>
                <Col>
                    <Button type='primary' onClick={onClickRecStart} style={{ margin: 10 }}>Start</Button>
                    <Button type='primary' onClick={onClickRecStop} style={{ margin: 10 }}>Stop</Button>
                </Col>

            </Row>

            <Row align='middle' style={{ margin: 10 }}>
                <Col>Rec Test Mode:</Col>
                <Col>
                    <Button type='primary' onClick={onClickPCMRecStart} style={{ margin: 10 }}>Start</Button>
                    <Button type='primary' onClick={onClickPCMRecStop} style={{ margin: 10 }}>Stop</Button>
                    <Button type='primary' onClick={onClickPCMRecPause} style={{ margin: 10 }}>Pause</Button>
                    <Button type='primary' onClick={onClickPCMRecRestart} style={{ margin: 10 }}>Restart</Button>
                </Col>

            </Row>

            <Row align='middle' style={{ margin: 10 }}>
                <Col>Play Test Mode:</Col>
                <Col>
                    <Button type='primary' onClick={testPCMPlayback} style={{ margin: 10 }}>Start</Button>
                </Col>
            </Row>

            Only GetAnswer:
            <Row align='middle' style={{ margin: 10 }}>
                <Col>
                    <Input value={currentUserMessage} onChange={handleUserInputChange} onPressEnter={onClickSendGetAnswer} />
                </Col>
                <Col>
                    <Button type='primary' onClick={onClickSendGetAnswer} style={{ margin: 10 }}>Send</Button>
                </Col>
            </Row> */}

        </div>



    )
}

export default ChatNoAudio;
